export const shouldExpireSessionForEndpoint = (endpointName?: string) => endpointName !== 'createEmployeeProfile'
